import React, { useEffect, useState } from "react";
import { Button, Modal, Form, ProgressBar, Alert } from "react-bootstrap";
import axios from "../../constents/axios"; // ✅ Ensure correct import

const ORACLE_STORAGE_URL = process.env.REACT_APP_ORACLE_STORAGE_URL;
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;


const UploadReel = ({ show, handleClose, onSuccess }) => {
  const [formState, setFormState] = useState({
    file: null,
    topic: "",
    description: "",
    isFreeReel: false,
    selectedSubject: "",
  });
  const [subjects, setSubjects] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState({ type: "", text: "" });

  // Reset Form
  const resetForm = () => {
    setFormState({
      file: null,
      topic: "",
      description: "",
      isFreeReel: false,
      selectedSubject: "",
    });
    setMessage({ type: "", text: "" });
    setProgress(0);
  };

  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setMessage({ type: "", text: "" });
  };

  // Handle File Change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormState((prev) => ({ ...prev, file }));
    }
  };

  // Handle Upload
  const uploadToOracle = async () => {
    if (!formState.file || !formState.topic || !formState.selectedSubject) {
      setMessage({ type: "error", text: "Please fill all required fields." });
      return;
    }

    setIsUploading(true);
    setProgress(0);

    const file = formState.file;
    const fileName = `${Date.now()}-${file.name}`;
    const fileUrl = `${ORACLE_STORAGE_URL}eduReels/${encodeURIComponent(fileName)}`; // ✅ Fixed URL formatting

    try {
      const response = await axios.put(fileUrl, file, {
        headers: {
          "Content-Type": file.type,
          Authorization: AUTH_TOKEN,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          setProgress(percentCompleted);
        },
      });

      const updatedUrl = fileUrl.replace(
        "/p/jIul8gp04uV3Vwlb3zpEhXkRU1NVb8KdpdLMRya9OzTvgDs85JfcSd_kezfBr4IA",
        ""
      );

      if (response.status === 200) {
        // ✅ Send uploaded file URL to backend
        await axios.post("/createReel", {
          reel: updatedUrl,
          fileName,
          topic: formState.topic,
          description: formState.description === "" ? "....." : formState.description,
          isFree: formState.isFreeReel,
          subject: formState.selectedSubject,
        });

        setMessage({ type: "success", text: "Upload successful!" });
        onSuccess();
        resetForm();
        handleClose();
      } else {
        throw new Error("Failed to upload video to Oracle.");
      }
    } catch (error) {
      console.error("Oracle upload error:", error);
      setMessage({ type: "error", text: "Upload failed. Please try again." });
    } finally {
      setIsUploading(false);
    }
  };

  // Fetch Subjects
  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const endpoint = formState.isFreeReel
          ? "/getFreeSubjects"
          : "/getPremiumSubjects";
        const { data } = await axios.get(endpoint);
        setSubjects(data);
      } catch (error) {
        console.error("Error fetching subjects:", error);
        setSubjects([]);
      }
    };
    fetchSubjects();
  }, [formState.isFreeReel]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload New Reel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message.text && (
          <Alert
            variant={message.type === "error" ? "danger" : "success"}
            className="mt-2"
          >
            {message.text}
          </Alert>
        )}
        <Form>
          <Form.Group className="mt-3">
            <Form.Label><span className="text-danger">*</span>Upload Reel</Form.Label>
            <Form.Control type="file" accept="video/*" disabled={isUploading} onChange={handleFileChange} />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label><span className="text-danger">*</span>Topic</Form.Label>
            <Form.Control
              type="text"
              name="topic"
              value={formState.topic}
              onChange={handleInputChange}
              placeholder="Enter topic"
              disabled={isUploading}
            />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              name="description"
              value={formState.description}
              onChange={handleInputChange}
              placeholder="Enter description"
              disabled={isUploading}
            />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Check
              type="checkbox"
              name="isFreeReel"
              label="Free Reel"
              checked={formState.isFreeReel}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group className="mt-3">
            <Form.Label><span className="text-danger">*</span>Choose Subject</Form.Label>
            <Form.Control
              as="select"
              name="selectedSubject"
              value={formState.selectedSubject}
              onChange={handleInputChange}
              disabled={isUploading}
            >
              <option value="">Select Subject</option>
              {subjects.map((subject, index) => (
                <option key={index} value={subject.subject}>
                  {subject.subject}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
        {/* Progress Bar */}
        {isUploading && (
          <div className="mt-4">
            <ProgressBar now={progress} label={`${progress}%`} animated />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isUploading}>
          Close
        </Button>
        <Button variant="primary" onClick={uploadToOracle} disabled={isUploading}>
          {isUploading ? "Uploading..." : "Upload Reel"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadReel;
